export interface LinkedSimData {
  iccid: string,
  tariffName: string
}